<!-- ===== COMENTÁRIOS PANEL ===== -->
<div class="section-title">
  <mat-icon>chat</mat-icon>
  <span>Comentários</span>
  <span class="status-badge badge-cinza">{{ comments.length }}</span>
</div>
@for (c of comments; track $index) {
  <div class="ced-comment-card">
    <span class="ced-avatar" [style.background]="c.whoColor || getPerson(c.who).color">{{ c.who }}</span>
    <div class="ced-comment-body">
      <div class="ced-comment-head">
        <b>{{ c.whoName || getPerson(c.who).name }}</b>
        <span>· {{ c.when }}</span>
      </div>
      <div class="ced-comment-text">
        @for (part of commentParts(c.text); track $index) {
          @if (part.type === 'mention') {
            <span class="ced-mention"><mat-icon class="material-symbols-outlined">alternate_email</mat-icon>{{ part.value }}</span>
          } @else {
            <span>{{ part.value }}</span>
          }
        }
      </div>
    </div>
  </div>
}

<!-- Composer -->
<div class="ced-cmt-composer">
  <textarea #commentInput class="ced-cmt-textarea" rows="3"
    placeholder="Escreva um comentário… use @ para mencionar alguém"
    [value]="draft"
    (input)="onDraftChange($event)"
    (keydown.escape)="mention = null"
    (keydown.control.enter)="postComment()"
    (keydown.meta.enter)="postComment()"></textarea>

  @if (mention && mentionSuggestions.length) {
    <div class="ced-cmt-mentions">
      <div class="ced-cmt-mentions-label">Mencionar pessoa</div>
      @for (p of mentionSuggestions; track p.idUsuario) {
        <button type="button" class="ced-cmt-mention-opt" (mousedown)="$event.preventDefault(); insertMention(p)">
          <span class="ced-avatar" [style.background]="p.color">{{ p.key }}</span>
          <span>{{ p.name }}</span>
        </button>
      }
    </div>
  }

  <div class="ced-cmt-actions">
    <span class="ced-cmt-hint">Ctrl+Enter para enviar</span>
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="postingComment"
      [disabled]="!draft.trim() || postingComment" [attr.aria-label]="postingComment ? 'Enviando comentário' : 'Comentar'"
      (click)="postComment()">
      Comentar
      @if (postingComment) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
  </div>
</div>
